import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["apiClient", "engagementId", "subjectObjectId", "subjectObjectIds", "subjectObjectTypeId", "onDefaultAssociationsLoaded", "associationRecords", "engagementOrInteractionType", "isError", "isLoading", "betAssociationsCount", "betSelect", "buttonUse", "canEdit", "canView", "labelKeyWhenNotEditable", "placement", "popoverLabelKey", "shouldDisableLastAssociation", "skeletonStateWidth", "size"];
import { useEffect } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import UniversalAssociationsSelect from './UniversalAssociationsSelect';
import { useUniversalAssociations } from '../hooks';
import { OrderedMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
function UniversalAssociationsSelectV2(_ref) {
  let {
      apiClient = undefined,
      engagementId,
      subjectObjectId,
      subjectObjectIds,
      subjectObjectTypeId,
      onDefaultAssociationsLoaded,
      // v1 props
      associationRecords: overriddenAssociationRecords,
      engagementOrInteractionType,
      isError = undefined,
      isLoading = undefined,
      // v1 default props
      betAssociationsCount = 0,
      betSelect = null,
      buttonUse = 'link',
      canEdit = false,
      canView = true,
      labelKeyWhenNotEditable = 'universalAssociationsSelect.selectedAssociationsLabel',
      placement = 'bottom right',
      popoverLabelKey = 'universalAssociationsSelect.button',
      shouldDisableLastAssociation = true,
      skeletonStateWidth = 175,
      size = 'small'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    associationRecords: universalAssociationRecords,
    isLoading: isUniversalAssociationRecordsLoading,
    isError: isUniversalAssociationRecordsError
  } = useUniversalAssociations({
    apiClient,
    engagementId,
    engagementType: engagementOrInteractionType,
    subjectObjectId,
    subjectObjectIds,
    subjectObjectTypeId
  });
  const previousAssociations = usePrevious(universalAssociationRecords) || OrderedMap();
  const previousError = usePrevious(isUniversalAssociationRecordsError);
  useEffect(() => {
    if (onDefaultAssociationsLoaded) {
      if (isUniversalAssociationRecordsError && !previousError) {
        onDefaultAssociationsLoaded(null);
      } else if (!isUniversalAssociationRecordsLoading && !universalAssociationRecords.equals(previousAssociations)) {
        onDefaultAssociationsLoaded(universalAssociationRecords);
      }
    }
  }, [isUniversalAssociationRecordsError, isUniversalAssociationRecordsLoading, onDefaultAssociationsLoaded, previousAssociations, previousError, universalAssociationRecords]);
  const associationRecords = overriddenAssociationRecords && overriddenAssociationRecords.size ? overriddenAssociationRecords : universalAssociationRecords;
  return /*#__PURE__*/_jsx(UniversalAssociationsSelect, Object.assign({
    associationRecords: associationRecords,
    apiClient: apiClient,
    engagementOrInteractionType: engagementOrInteractionType,
    isError: isError !== undefined ? isError : isUniversalAssociationRecordsError,
    isLoading: isLoading !== undefined ? isLoading : isUniversalAssociationRecordsLoading,
    betAssociationsCount: betAssociationsCount,
    betSelect: betSelect,
    buttonUse: buttonUse,
    canEdit: canEdit,
    canView: canView,
    labelKeyWhenNotEditable: labelKeyWhenNotEditable,
    placement: placement,
    popoverLabelKey: popoverLabelKey,
    shouldDisableLastAssociation: shouldDisableLastAssociation,
    skeletonStateWidth: skeletonStateWidth,
    size: size
  }, rest));
}
export default UniversalAssociationsSelectV2;